<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <form @submit.prevent="saveLabel">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Edit label') }}</h1>
                    </div>
                    <div class="mt-4 flex md:mt-0 md:ml-4">
                        <button
                            class="btn btn-red shadow-sm rounded"
                            type="button"
                            @click="deleteLabelModal = true"
                        >
                            {{ $t('Delete label') }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-6 shadow sm:rounded-sm">
                    <loading :status="loading"/>
                    <div class="bg-white md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
                        <div class="md:col-span-1">
                            <h3 class="text-lg font-medium leading-6 text-gray-900">{{ $t('Label details') }}</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                                {{ $t('Label details and customization') }}.
                            </p>
                        </div>
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="name">{{ $t('Name') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <input
                                            id="name"
                                            v-model="label.name"
                                            :placeholder="$t('Name')"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                            required
                                        >
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <input-color id="color" v-model="label.color" :label="$t('Color')" :placeholder="$t('Pick a color')" required></input-color>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="stage-footer-surface text-right px-4 py-3 sm:px-6">
                        <span class="inline-flex">
                            <router-link
                                class="btn btn-secondary shadow-sm rounded mr-4"
                                to="/workspace/admin/settings/labels"
                            >
                                {{ $t('Close') }}
                            </router-link>
                            <button
                                class="btn btn-gray shadow-sm rounded"
                                type="submit"
                            >
                                {{ $t('Edit label') }}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </form>
        <confirm-dialog
            :open="deleteLabelModal"
            :title="$t('Delete label').toString()"
            :text="`${$t('Are you sure you want to delete the label?')} ${$t('All data will be permanently removed')}. ${$t('All related data will be deleted')}. ${$t('This action cannot be undone')}.`"
            :confirm-label="$t('Delete label').toString()"
            confirm-variant="danger"
            @close="deleteLabelModal = false"
            @confirm="deleteLabel"
        />
    </main>
</template>

<script>
import ConfirmDialog from '@/components/modals/confirm-dialog.vue';

export default {
    components: {ConfirmDialog},
    name: "edit",
    metaInfo() {
        return {
            title: this.$i18n.t('Edit label')
        }
    },
    data() {
        return {
            loading: true,
            deleteLabelModal: false,
            label: {
                name: null,
                color: '#2196F3',
            },
        }
    },
    mounted() {
        this.getLabel();
    },
    methods: {
        saveLabel() {
            const self = this;
            self.loading = true;
            axios.put('api/workspace/admin/labels/' + self.$route.params.id, self.label).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        getLabel() {
            const self = this;
            self.loading = true;
            axios.get('api/workspace/admin/labels/' + self.$route.params.id).then(function (response) {
                self.label = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        deleteLabel() {
            const self = this;
            axios.delete('api/workspace/admin/labels/' + self.$route.params.id).then(function () {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data deleted successfully').toString(),
                    type: 'success'
                });
                self.$router.push('/workspace/admin/settings/labels');
            }).catch(function () {
                self.deleteLabelModal = false;
            });
        },
    }
}
</script>
